import { useApiAbortStore } from "src/stores/apiAbortStore"
import { useApiCallStore } from "src/stores/apiCallStore"
import { useAuthStore } from "src/stores/authStore"
import { useCapacitorAppInfoStore } from "src/stores/capacitorAppInfoStore"
import { useConfigurationStore } from "src/stores/configurationStore"
import { useSearchStore } from "src/stores/searchStore"
import { useSupportStore } from "src/stores/supportStore"
import { useToDoItemsStore } from "src/stores/todoItemsStore"
import { useTopNavigationStore } from "src/stores/topNavigationStore"
import { useUserStore } from "src/stores/userStore"

export function clearLocalStorage() {
  localStorage.clear()
}

export function resetPiniaStores() {
  const authStore = useAuthStore()
  const apiCallStore = useApiCallStore()
  const apiAbortStore = useApiAbortStore()
  const capacitorAppInfoStore = useCapacitorAppInfoStore()
  const configurationStore = useConfigurationStore()
  const searchStore = useSearchStore()
  const supportStore = useSupportStore()
  const todoItemsStore = useToDoItemsStore()
  const topNavigationStore = useTopNavigationStore()
  const userStore = useUserStore()

  authStore.$reset()
  apiCallStore.$reset()
  apiAbortStore.$reset()
  capacitorAppInfoStore.$reset()
  configurationStore.$reset()
  searchStore.$reset()
  supportStore.$reset()
  todoItemsStore.$reset()
  topNavigationStore.$reset()
  userStore.$reset()
}
